<template>
  <div class="dynamic-attr-text" :class="(attrObj.isCheckError?'is-check-error':'')">
    <div
      :class="'dynamic-attr-text-title '+ (attrObj.mustFlag=='1'?'is-item-required':'')"
      :style="{fontSize:$pScreen.titleS}"
    >
      <span>{{ showNum(attrObj, currentPage) }} {{ attrObj.title }}</span>
    </div>
    <div
      class="text-item-value text-item-input"
      :style="{'margin-bottom': attrObj.isCheckError ? '0' : '15px'}"
    >
      <Input
        v-model="attrObj.answerContent"
        size="default"
        :disabled="attrObj.disabled"
        placeholder="请输入你的姓名"
        @on-blur="blur" />
      <div v-if="attrObj.isCheckError" class="errorTip">{{ attrObj.errorMsg || errorMsg }}</div>
    </div>
  </div>
</template>

<style scoped>
  .dynamic-attr-text .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }
  .dynamic-attr-text .action {
    width: 26%;
    font-size: 12px;
    text-align: center;
    border: 1px solid #dcdee2 !important;
    border-radius: 8px;
    background: #fff;
    color: #333;
  }
  .dynamic-attr-text .action:focus, .dynamic-attr-text .action:disabled, .dynamic-attr-text .action:active {
    background: #fff;
    color: #333;
  }
</style>


<script>
import { FormType } from '../../../../commons/commonVariables.js';
export default {
  props: {
    attrObj: Object,
    currentPage: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      errorMsg: '请输入你的姓名'
    }
  },
  created() {},
  methods: {
    // 姓名必填校验
    blur() {
      if (this.attrObj.mustFlag == '1') {
        if (this.attrObj.answerContent && this.attrObj.answerContent.trim()) {
          this.$set(this.attrObj, "isCheckError", false);
        } else {
          this.$set(this.attrObj, "isCheckError", true);
        }
      }
    },
    // 只有趣味表单才展示题号
    showNum(item, current){
      if(item.formType !== FormType.interestForm){
        return ''
      } else {
        return `${current + 1}.`
      } 
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/nameText.vue